import React from "react";
import styles from "./page8.module.scss";
import image from "../../images/building.svg";
import dots from "../../images/dots.svg";
import dots2 from "../../images/dots2.svg";
import { Button } from "@mui/material";
import arrow from "../../images/arrowWhite.svg";
import textImage from "../../images/textimage.svg";
export default function Page8() {
  return (
    <div className={styles.mainwrapper}>
      <div className={styles.left}></div>
      <div className={styles.right}>
        <div className={styles.dotscontainer}>
          <img className={styles.dots} src={dots} alt="dots" />
        </div>
        <div className={styles.textContent}>
          <div className={styles.heading}>
            <p>Bring your ideas to life with Firstock Connect</p>
          </div>
          <div className={styles.button}>
            <Button
              startIcon={
                <div
                  style={{
                    background: "#6D00FF",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px",
                  }}
                >
                  <img src={arrow} />
                </div>
              }
              variant="outlined"
              sx={{
                my: 2,
                color: "black",
                fontWeight: "600",

                // bgcolor: "#6D00FF",
                padding: "5px 20px 5px 10px",
                borderRadius: "50px",
                textTransform: "none",
                "&:hover": {
                  bgcolor: "#6D00FF",
                  transition: "0.3s ease-in-out",
                  color: "white",
                  "& .MuiButton-startIcon": {
                    transform: "rotate(45deg)",
                    transition: "0.3s ease-in-out",
                  },
                },
              }}
            >
              Get Started
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
